import React from 'react';
import AllRoute from '../router'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../../sass/style.scss';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '../../hooks/useFetch';


const App = () => {

  return (
    <div className="App" id='scrool'>
      <QueryClientProvider client={queryClient}>
        <AllRoute />
        <ToastContainer />
      </QueryClientProvider>
    </div>
  );
}

export default App;
